<template>
  <div class="configurator-step-intermission">
    <div>
        <h2 class="dealer-intermission__title">
          <i class="fa fa-check-circle" aria-hidden="true"></i> Vielen Dank für Ihre Nachricht
        </h2>
        <p class="dealer-intermission__text">
          Wir überprüfen nun Ihre Angaben und senden Ihnen die Preisbewertung Ihres Fahrzeugs,
          sowie ein unverbindliches Angebot per E-Mail zu.
        </p>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'ConfiguratorStepDealerIntermission',
        props: ['name', 'options'],
        data: function() {
            return {
                finished: false
            }
        },
    }
</script>

<style lang="scss" scoped>

  * {
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 transparent;
  }
  *:hover {
    scrollbar-width: thin;
    scrollbar-color: #999999 transparent;
  }
  *::-webkit-scrollbar {
    width: 8px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 20px;
  }
  *::-webkit-scrollbar-thumb:hover {
    background-color: #999999;
  }

  @import "~@/assets/vars";
  @import '~@widget/assets/colors';

  .configurator-step-intermission {
    display: flex;
    height: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 15px;
  }

  .dealer-intermission__title {
    color: $widget-green;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .dealer-intermission__text {
    font-size: 16px;
    color: $widget-dark;
    max-width: 510px;
  }

  .fa-check-circle {
    display: inline-block;
    top: 3px;
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepDealerIntermission.vue